import { createReducer } from '../../../utils/misc';

import {
  LOGIN_SUCCESS,
  LOGIN_REQUEST,
  LOGIN_FAILURE,
  LOGIN_NOT_MADE,
  LOGOUT_SUCCESS,
  LOGOUT_REQUEST,
  CLEAR_ERROR
} from '../../../constants/index';

export const initialState = {
  changePassword: null,
  isAuthenticated: false, // false -> no està autenticat, true -> està autenticat.
  isAuthenticating: true, // false -> no està autenticant, true -> està autenticant.
  newCustomer: false,
  statusCode: null,
  status: 'success', // error, success
  type: "none"
};

export const reducerMap = {
  [LOGIN_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: true,
      newCustomer: payload?.newCustomer,
      statusCode: null,
      status: 'success'
    })
  },
  [LOGIN_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: false,
      statusCode: payload?.statusCode,
      status: payload?.status
    })
  },
  [LOGIN_NOT_MADE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticating: false,
      statusCode: payload?.statusCode,
      status: payload?.status,
      type: 'none' // I'm not sure if this is preferable to handling all the types in the AuthProtectionProvider
    })
  },
  [CLEAR_ERROR]: (state) => 
    Object.assign({}, state, initialState), 
  [LOGIN_REQUEST]: (state, payload) => 
    Object.assign({}, state, {
      isAuthenticating: true,
      type: payload.type
    }),
  [LOGOUT_REQUEST]: (state) =>
    Object.assign({}, state, {
      type: "logout"
    }),
  [LOGOUT_SUCCESS]: (state) =>
    Object.assign({}, state, {
      isAuthenticating: false,
      isAuthenticated: false
    })
};

export default createReducer(initialState, reducerMap);
